module.exports = __webpack_public_path__ + "img/badge_gold.7f956ae0.png";